import {ObvioEvent} from 'Event'
import {
  ObieAttendeeLink,
  ObieAttendeeLinkData,
  ObieAttendeeLinkError,
} from 'lib/event-api/integrations/obie/attendee-links/list'
import {Client} from 'lib/ui/api-client'
import {api} from 'lib/url'
import {useMutation, useQueryClient} from 'react-query'

export function useAddObieAttendeeLink(params: {
  client: Client
  event: ObvioEvent
}) {
  const {client, event} = params
  const qc = useQueryClient()

  return useMutation<
    ObieAttendeeLink,
    ObieAttendeeLinkError,
    ObieAttendeeLinkData
  >({
    mutationFn: (data) =>
      client.post<ObieAttendeeLink>(
        api(`/events/${event.id}/integrations/obie/attendee_links`),
        data,
      ),
    onSuccess: (link) => {
      qc.setQueryData<ObieAttendeeLink[]>(
        ['events', event.id, 'integrations', 'obie', 'attendee_links'],
        (links) => {
          if (!links) {
            return [link]
          }

          return [...links, link]
        },
      )
    },
  })
}
